<template>
	<div style="padding: 10px 10px 10px 0;">
		<el-tabs v-model="flag" @tab-click="goChange()">
			<el-tab-pane label="停车优惠" name="停车优惠">
				<el-form :inline="true" :model="form" class="demo-form-inline">
					<div class="flex sb">
						<div>
							<el-form-item label="录入时间">
								<el-date-picker v-model="form.createTimeStart" type="datetime" placeholder="录入开始时间">
								</el-date-picker>
								<span>-</span>
								<el-date-picker v-model="form.createTimeEnd" type="datetime" placeholder="录入结束时间">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="商铺编号">
								<el-input v-model="form.shopNum" placeholder="商铺编号"></el-input>
							</el-form-item>
							<el-form-item label="购物小票号">
								<el-input v-model="form.code" placeholder="购物小票号"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="getAll">查询</el-button>
								<el-button type="primary" @click="cz">重置</el-button>
							</el-form-item>
							<el-form-item>
								<div style="font-size: 25px;">共计{{count}}条记录</div>
							</el-form-item>
							<el-form-item>
								<div style="font-size: 25px;">共计抵扣{{sum}}小时</div>
							</el-form-item>
						</div>
				
					</div>
				</el-form>
				<el-table :data="data" style="width: 100%" border>
					<el-table-column prop="shopNum" label="商铺编号" width="100"></el-table-column>
					<el-table-column prop="shopName" label="商铺名称" width="300"></el-table-column>
					<el-table-column prop="carNum" label="优惠车牌号"></el-table-column>
					<el-table-column prop="discount" label="优惠时长(小时)"></el-table-column>
					<el-table-column prop="money" label="优惠金额"></el-table-column>
					<el-table-column prop="code" label="购物小票号"></el-table-column>
					<el-table-column prop="userName" label="操作人"></el-table-column>
					<el-table-column prop="createTime" label="录入时间">
						<template slot-scope="{row}">{{setTime(row.createTime)}}</template>
					</el-table-column>
				</el-table>
				<el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="count">
				</el-pagination>
			</el-tab-pane>
			<el-tab-pane label="积分抵扣" name="积分抵扣">
				<el-form :inline="true" :model="form" class="demo-form-inline">
					<div class="flex sb">
						<div>
							<el-form-item label="抵扣时间">
								<el-date-picker v-model="form.createTimeStart" type="date" placeholder="抵扣开始时间">
								</el-date-picker>
								<span>-</span>
								<el-date-picker v-model="form.createTimeEnd" type="date" placeholder="抵扣结束时间">
								</el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="getAll">查询</el-button>
								<el-button type="primary" @click="cz">重置</el-button>
							</el-form-item>
							<el-form-item>
								<div style="font-size: 25px;">共计{{count}}条记录</div>
							</el-form-item>
							<el-form-item>
								<div style="font-size: 25px;">共计优惠{{sum}}积分</div>
							</el-form-item>
						</div>
				
					</div>
				</el-form>
				
				<el-table :data="data" style="width: 100%" border>
					<el-table-column prop="createTime" label="抵扣时间">
						<template slot-scope="{row}">{{setTime(row.createTime)}}</template>
					</el-table-column>
					
					<el-table-column prop="score" label="抵扣积分数"></el-table-column>
					<!--el-table-column prop="openId" label="openid"></el-table-column-->
					<el-table-column prop="remark" label="备注"></el-table-column>
				</el-table>
				<el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="count">
				</el-pagination>
			</el-tab-pane>
		</el-tabs>
<!-- 		<el-dialog title="详情" :visible.sync="show" width="40%">
			<el-form :model="obj" label-width="120px">
				<el-row>
					<el-col :span="12">
						<el-form-item prop="visitor" label="访客姓名">
							<el-input v-model="obj.visitor" disabled=""></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="phone" label="访客手机号">
							<el-input v-model="obj.phone" disabled=""></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item prop="idCard" label="访客身份证号">
							<el-input v-model="obj.idCard" disabled=""></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="intervieweeName" label="被访人姓名">
							<el-input v-model="obj.intervieweeName" disabled=""></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item prop="roomNumber" label="被访问人房间号">
							<el-input v-model="obj.roomNumber" disabled=""></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="consumption" label="访问时间">
							<el-input v-model="obj.visitingTime" disabled=""></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item prop="departureTime" label="访问结束时间">
							<el-input v-model="obj.departureTime" disabled=""></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="createTime" label="提交时间">
							<el-input v-model="obj.createTime" disabled=""></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item prop="reason" label="来访原因">
							<el-input type="textarea" rows="10" v-model="obj.reason" disabled=""></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="createTime" label="苏康码">
							<img style="width: 100px;" :src="obj.showHealthPath" alt="">
						</el-form-item>
						<el-form-item prop="createTime" label="行程码">
							<img style="width: 100px;" :src="obj.showTripPath" alt="">
						</el-form-item>
						
					</el-col>
				</el-row>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">关 闭</el-button>
			</span>
		</el-dialog> -->

	</div>
</template>

<script>
	export default {
		data() {
			return {
				sum:null, 
				flag:'停车优惠',
				count: 0,
				users: [], //申请人
				show: false,
				form: {
					createTimeStart:null,
					createTimeEnd:null,
					shopNum:null,
					currentPage: 1,
					pageSize: 10,
				},
				oldForm:{
					
				},
				addForm: {},
				data: [],
				obj: {
					fileRes: ""
				}, //详情数据
			}
		},
		methods: {
			goChange(){
				this.form=JSON.parse(JSON.stringify(this.oldForm))
				this.getAll()
			},
			cz() {
				this.form = {
					createTimeStart:null,
					createTimeEnd:null,
					shopNum:null,
					currentPage: 1,
					pageSize: 10,
				}
				this.getAll()
			},

			lookRow(obj) {
				this.obj = {
					...obj
				}
				this.show = true;
			},
			handleCurrentChange(val) {
				this.form.currentPage = val;
				this.getAll()
			},
			handleSizeChange(val) {
				this.form.pageSize = val;
				this.getAll()
			},

			getAll() { //获取表格数据
			var url
				if(this.flag=='停车优惠'){
					 url="/api/parkingDiscount/queryParkingDiscount"
				}else{
					 url='/api/parkingDiscount/getPayScore'
				}
				
				this.$http.post(url, {
					...this.form
				}).then(res => {
					console.log(res)
					if (res.data.data != null) {
						this.count = res.data.data.totalNum;
						this.data = res.data.data.items
						
						this.sum=res.data.data.sum
					} else {
						this.count = 0
						this.data = null
						this.sum=0
					}

				})
			}
		},
		created() {
			this.oldForm=JSON.parse(JSON.stringify(this.form))
			this.getAll();

		}
	}
</script>

<style scoped="scoped">
	.box {
		font-size: 16px;
		width: 70%;
	}

	.box>div {
		margin-bottom: 10px;
	}
</style>
